<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Review Exchange Assets'" [level]="5"></fui-heading>
</div>
<div class="row">
  <div class="col-md-12">
    @if (wares?.data) {
      <myp-exchange-list (itemTapped)="viewExchangeDetail($event)" [limit]="1000" [wares]="wares"></myp-exchange-list>
    }
  </div>
</div>
